import { getOffsetMinutesToMoscow } from '@/modules/common/helpers/get-offset-minutes-to-moscow.helper';
import { indicateWheatType } from '@/modules/common/helpers/wheat-type.helper';
import { OfferDetails } from '@/modules/mixing/ts/buyers-prices.types';
import { IInitialFormState } from '@/modules/seller-account/hooks/use-add-offer.hook';
import {
  fetchBuyerOffersListFx,
  updateOfferFx,
} from '@/modules/seller-account/store/offers.store';
import { BuyerInstance } from '@/modules/seller-account/ts';
import { notification } from 'antd';
import md5 from 'md5';

export const handleUpdate = async ({
  date,
  closeFn,
  formState,
  buyerInfo,
  offerToEdit,
  setOfferToEdit,
  refetchBuyersList,
  indicatedClass
}: IArgs) => {
  const offsetMinutes = new Date().getTimezoneOffset(); // getOffsetMinutesToMoscow();
  // const unixTimestamp =
  //   new Date(date.year, date.month - 1, date.day, date.hours, date.minutes).getTime() /
  //     1000 -
  //   offsetMinutes * 60;
  const unixTimestamp =
  new Date(date.year, date.month - 1, date.day, date.hours, date.minutes).getTime() / 1000;
  if (offerToEdit) {
    console.log(date)
      console.log(unixTimestamp)
    const res = await updateOfferFx({
      id: Number(offerToEdit.id),
      type: buyerInfo.type,
      dto: {
        year: String(formState.year),
        gluten: String(formState.gluten),
        idk: String(formState.idk),
        clop: String(formState.clop),
        protein: String(formState.protein),
        cp: String(formState.cp),
        nature: String(formState.nature),
        humidity: String(formState.humidity),
        weed: String(formState.weed),
        admixture_other_cereals: String(formState.admixtureOtherCereals),
        wheat_different_type: String(formState.wheatDifferentType),
        price: String(formState.buyingPrice),
        buyer_id: String(offerToEdit.buyer_id ?? 0),
        expiration_offer: String(unixTimestamp),
        wheat_class: indicatedClass > 0 ? String(indicatedClass) :  String(formState.wheatClass),
        wheat_type: String(
          indicateWheatType(String(formState.sort), String(formState.type)),
        ),
        pickup: formState.pickup,
        //class: "",
      },
    });
    if ('error' in res) {
      try {
        const errorRes = res as any;
        const errorArray =
          errorRes?.error?.errors &&
          Object.keys(errorRes?.error?.errors).reduce((result, key) => {
            return result.concat(errorRes.error.errors[key]);
          }, []);
        if (errorArray && errorArray?.length > 0) {
          errorArray.map((item: string) => notification.error({ message: item }));
          return;
        }
        if (typeof errorRes?.error === 'string') {
          notification.error({ message: errorRes.error });
          return;
        }
        if (typeof errorRes === 'string') {
          notification.error({ message: errorRes });
          return;
        }
      } catch (err) {
        return notification.error({
          message: 'Непредвиденная ошибка. Попробуйте позже.',
        });
      }
    }
    notification.success({ message: 'Предложение успешно обновлено в системе!' });
    await fetchBuyerOffersListFx({
      id: buyerInfo?.id,
      md5: buyerInfo?.type === 'external' ? md5(buyerInfo?.company_name) : undefined,
    });
    refetchBuyersList && (await refetchBuyersList());
    setOfferToEdit(null);
    closeFn();
  }
};

interface IArgs {
  date: {
    year: number;
    month: number;
    day: number;
    hours: number;
    minutes: number;
  };
  closeFn: () => void;
  formState: IInitialFormState;
  buyerInfo: any;
  offerToEdit: OfferDetails;
  setOfferToEdit: (val: OfferDetails | null) => void;
  refetchBuyersList?: () => Promise<BuyerInstance[] | undefined>;
  indicatedClass: number;
}
